export const CHANGE_QUERYSTRING = 'CHANGE_QUERYSTRING';
import {ACTION_TYPES as types} from './action-types';

export const setSearchedResults = (results) => {
  return {
    type: types.SET_SEARCHED_RESULTS,
    results,
  };
};
export const setCategories = (categories) => {
  return {
    type: types.SET_CATEGORIES,
    categories,
  };
};

export const fetchFromAPI = (path) => {
  return {
    type: 'FETCH_FROM_API',
    path,
  };
};